import { render } from "./FileDownloader.vue?vue&type=template&id=7e980c7a&scoped=true"
import script from "./FileDownloader.vue?vue&type=script&lang=js"
export * from "./FileDownloader.vue?vue&type=script&lang=js"

import "./FileDownloader.vue?vue&type=style&index=0&id=7e980c7a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7e980c7a"]])

export default __exports__